/* 
Allows for inline text links to trigger specified Vue modals

*/

import Vue from 'vue/dist/vue.min.js';
import VModal from 'vue-js-modal';
import {formModal, exitModal} from './modals';
import EventBus from './event-bus';
import store from './store';

Vue.use(VModal);

const instance = new Vue({
    methods: {
        triggerContactTooltip() {
            EventBus.$emit('toggle-contact');
        },

        triggerForm(data) {
            this.$modal.show(
                formModal.template(data.content),
                formModal.name(data.name), 
                formModal.options(data.options),
                formModal.events(data.data)
            )
        },

        triggerExit(data) {
            this.$modal.show(
                exitModal.template(data),
                exitModal.name, 
                exitModal.options,
                exitModal.events
            )
        },
        closeModal(name) {
            // this.$modal.hide(name);
            this.$modal.hideAll();
        }
    }
});

const trigger = () => {        
    document.addEventListener('click', (e) => { 
        if (e.target.getAttribute('href')) {
            var hrefHash = e.target.getAttribute('href').split("#")[1];            
            if (!e.target.classList.contains("leavingSiteClickEventAdded") && hrefHash) {

                if (hrefHash === "contactustip") {
                    e.preventDefault();
                    instance.triggerContactTooltip();
                } 
                if (window.modalHashtags) {
                    window.modalHashtags.forEach((item) => {
                        if (hrefHash === item.hashtagname) {
                            e.preventDefault();
                            let downloadUrl = e.target.dataset.downloadUrl || null;
                            let downloadName = e.target.dataset.downloadName || null;
                            let selectedProducts = e.target.dataset.quoteProducts || null;
                            let productCategory = e.target.dataset.productCategory || null;
                            let literatureOrdered = e.target.dataset.literatureOrdered || null;
                            let content = e.target.dataset.content || null;
                            let comments = e.target.dataset.comments || null;
                            let existingQueryParams = location.search;
                            
                            if (existingQueryParams != "") {
                                if (downloadUrl && downloadUrl != "") {
                                    existingQueryParams = "&" + existingQueryParams;
                                    existingQueryParams = existingQueryParams.replace("&&","&");
                                    if (existingQueryParams.startsWith("?")) 
                                        existingQueryParams = existingQueryParams.slice(1); // remove the question mark
                                } else {
                                    if (item.url.indexOf("?") > -1) {
                                        existingQueryParams = "&" + existingQueryParams;
                                        existingQueryParams = existingQueryParams.replace("&&","&");
                                    }
                                }
                            }
                            if (window.getFirstTouchCookies) { 
                                //***********************************************************************************************/
                                // NOTE:
                                // the  function `window.getFirstTouchCookies` will only be available if the user accepted cookies. This script is in the BACKEND CODE ONLY.
                                // This code is in the backend project only because it's cookie code and has to be disabled by an optanon-category from OneTrust if the user 
                                // does not accept cookies.
                                //***********************************************************************************************/
                                let FTCookies = window.getFirstTouchCookies();
                                let LTCookies = window.getLastTouchCookies();
                                function renameProperty(object, oldName, newName) { // .length of function is 2
                                    'use strict';
                                    if (oldName === newName) {
                                        return object;
                                    }
                                    if (object.hasOwnProperty(oldName)) {
                                        object[newName] = object[oldName];
                                        delete object[oldName];
                                    }
                                    return object;
                                }
                                renameProperty(FTCookies, 'utm_campaign_FT', 'UTM_Campaign_FT');
                                renameProperty(FTCookies, 'utm_content_FT', 'UTM_Content_FT');
                                renameProperty(FTCookies, 'utm_medium_FT', 'UTM_Medium_FT');
                                renameProperty(FTCookies, 'utm_source_FT', 'UTM_Source_FT');
                                renameProperty(FTCookies, 'utm_campaign_ID_FT', 'UTM_Campaign_ID_FT');
                                renameProperty(FTCookies, 'gclid_FT', 'GCLID_FT');
                                
                                renameProperty(LTCookies, 'utm_campaign_LT', 'UTM_Campaign_LT');
                                renameProperty(LTCookies, 'utm_content_LT', 'UTM_Content_LT');
                                renameProperty(LTCookies, 'utm_medium_LT', 'UTM_Medium_LT');
                                renameProperty(LTCookies, 'utm_source_LT', 'UTM_Source_LT');
                                renameProperty(LTCookies, 'utm_campaign_ID_LT', 'UTM_Campaign_ID_LT');
                                renameProperty(LTCookies, 'gclid_LT', 'GCLID_LT');

                                let cookieQueryString = "";
                                let ftKeys = Object.keys(FTCookies);
                                let ltKeys = Object.keys(LTCookies);

                                cookieQueryString = ftKeys.filter(x => x != "HasValues").map(key => `${key}=${FTCookies[key]}`).join("&");
                                cookieQueryString += "&" + ltKeys.filter(x => x != "HasValues").map(key => `${key}=${LTCookies[key]}`).join("&");
                                if (existingQueryParams != "") {
                                    existingQueryParams += "&" + cookieQueryString;
                                } else {
                                    existingQueryParams = "?" + cookieQueryString;
                                }
                                console.log("cookieQueryString", cookieQueryString);
                            }

                            if (existingQueryParams != "") {
                                existingQueryParams += "&product_category_selections=" + productCategory;
                            } else {
                                existingQueryParams += "?product_category_selections=" + productCategory;
                            }

                            if (comments || selectedProducts || literatureOrdered || downloadUrl || downloadName) {
                                instance.triggerForm({
                                    content: {
                                        url: downloadUrl && downloadUrl !== "" ? (`${item.url}?redirect_url=${downloadUrl}` + existingQueryParams) : (item.url + existingQueryParams),
                                        copy: `${content ? content : ``}`
                                    },
                                    name: item.hashtagname,
                                    options: {"classes": `bmi-modal bmi-modal--form bmi-modal--${item.hashtagname}`},
                                    data: {
                                        product_selections: selectedProducts,
                                        product_category_selections: productCategory,
                                        modalName: item.hashtagname,
                                        downloadName: downloadName,
                                        literatureOrdered,
                                        comments: comments,
                                    }
                                })
                            } else {
                                instance.triggerForm({
                                    content: {
                                        url: item.url + existingQueryParams,
                                        copy: `${content ? content : ``}`
                                    },
                                    name: item.hashtagname,
                                    options: {"classes": `bmi-modal bmi-modal--form bmi-modal--${item.hashtagname}`}
                                });
                            }                        
                        } 
                    });
                }           
            }
        } else {
            console.log('e.target', e.target);
            return;
        }
    });


    let leavingSiteClick =  (e) =>  { 
        if (window.leavingSite) {
            var data = {
                "copy": window.leavingSite.modalContent,
                "ok": window.leavingSite.okLabel,
                "close": window.leavingSite.closeLabel,
            } 
            var link = e.target.getAttribute('href');
            var target = e.target;
            var modal = document.querySelector('.bmi-modal--exit');
            
            for (let i=0; i < window.leavingSite.sites.length; i++) {
                let site = window.leavingSite.sites[i];
                if (modal && modal.contains(target)) {
                    continue;
                } else if (link.includes(`${site}`)) {
                    e.preventDefault();
                    
                    data = {
                        ...data,
                        "link": link
                    }
                    instance.triggerExit(data);
                    return false;
                }
            }
        }
    };

    document.addEventListener("click", function() {
        setTimeout(function() {
            document.querySelectorAll('a[href]').forEach(l => {    
                if (l.href.toLowerCase().indexOf("http") == -1) {
                    //check if 'eventAdded' class to the element
                    if (!l.classList.contains("leavingSiteClickEventAdded")) {
                        l.classList.add("leavingSiteClickEventAdded");
                        l.addEventListener('click', leavingSiteClick);
                    }
                }
            });
        }, 500);
    });

    // in order for the return false/e.preventDefault() to actually work, you must attach this to the anchor tag itself, not document.addEventListener
    // like it was previously. The problem is that this only works for anything that already exists on the DOM.
    // The above document.addEventListener() will add it for anything that's injected into the DOM, querying the dom 500ms after the click.
    // this is not ideal, but there's not really a better way to handle this.
    
    document.querySelectorAll('a[href]').forEach(l => {
        //add a 'eventAdded' class to the element
        if (l.href.toLowerCase().indexOf("http") == -1) {
            //check if 'eventAdded' class to the element
            if (!l.classList.contains("leavingSiteClickEventAdded")) {
                l.classList.add("leavingSiteClickEventAdded");
                l.addEventListener('click', leavingSiteClick);
            }
        }
    });
}

// export default trigger;
export { instance, trigger};
